import React from "react";
import CMSRender from "aldoo-ra/CMS/cms-render";
import PubSub from "pubsub-js";
import Typography from "aldoo-ra/Typography";
import Button from "aldoo-ra/Button";

const PricingBanner = () => {
  return (
    <CMSRender
      contentType="PageSection"
      match={{ "content.name": "Pricing Banner" }}
      renderItem={(data, id) => {
        const handleContact = () => {
          if (data.menu?.[0]?.options?.action === "open-contacts") {
            PubSub.publish("open-contacts")
          }
        }

        return (
          <div
            key={id}
            className="w-full px-[16px] md:px-px1_l xl:px-px1_xl mt-[90px]">
            {/* Blue Container */}
            <div className="relative w-full lg:max-w-w2_l xl:max-w-w2_xl  overflow-hidden bg-gradient_pricing_contact_sales rounded-[50px] md:rounded-[70px] mx-auto px-10 py-[55px]">
              {/* Center all content */}
              <div className="flex flex-col items-center text-center relative z-20 max-w-3xl mx-auto">
                <Typography 
                  variant="h2" 
                  className="text-text mb-[20px]"
                >
                  {data.title}
                </Typography>

                <Typography variant="body1" className="mb-[30px]">
                  {data.description}
                </Typography>

                <Button
                  onClick={handleContact}
                  variant="primary_l"
                  className="min-w-[214px]"
                >
                  {data.menu[0].label}
                </Button>
              </div>

              {/* Background image (same gradient as in main container) */}
              <div className="hidden md:block absolute inset-0 w-full h-full">
                {data.images?.[0] && (
                  <div className="absolute inset-0 overflow-hidden">
                    <div className="absolute inset-0 bg-gradient_pricing_contact_sales z-10" />
                    <img
                      src={data.images[0]}
                      alt="Business team"
                      className="absolute right-0 h-full object-right"
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        )
      }}
    />
  )
}

export default PricingBanner
